/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export enum LangIdentifiers {
  /** Spain */
  E = 'E',
  /** Portugal */
  P = 'P',
  /** Bulgary */
  B = 'B',
  /** Czech */
  C = 'C',
  /** Germany */
  A = 'A',
  /** Greece */
  G = 'G',
  /** US */
  I = 'I',
  /** France */
  F = 'F',
  /** Hungary */
  H = 'H',
  /** Italy */
  T = 'T',
  /** Japan */
  J = 'J',
  /** Poland */
  L = 'L',
  /** Rumainia */
  M = 'M',
  /** Russia */
  R = 'R',
  /** Turkey */
  K = 'K',
  /** Ukraine */
  U = 'U',
  /** China */
  X = 'X',
}
